import { render, staticRenderFns } from "./EnvelopeList.vue?vue&type=template&id=5123c8dd"
import script from "./EnvelopeList.vue?vue&type=script&lang=js"
export * from "./EnvelopeList.vue?vue&type=script&lang=js"
import style0 from "./EnvelopeList.vue?vue&type=style&index=0&id=5123c8dd&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports